import styled, { css } from 'styled-components';
import { APPS_PHONE_MEDIA } from '../../apps.constants';
import { COLUMN_FOLD_MS } from './builderWorkspace.constants';

const RAIL_STRIP_WIDTH = '48px';
const CHAT_WIDTH = 'clamp(320px, 28vw, 420px)';

export const LayoutRow = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;

  ${APPS_PHONE_MEDIA} {
    flex-direction: column;
  }
`;

interface PaneProps {
  readonly $phoneActive: boolean;
}

const phoneVisibility = css<PaneProps>`
  ${APPS_PHONE_MEDIA} {
    display: ${({ $phoneActive }) => ($phoneActive ? 'flex' : 'none')};
    flex: 1 1 auto;
    width: auto;
    border: none;
  }
`;

const pane = css`
  flex-direction: column;
  min-width: 0;
  min-height: 0;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const RailPane = styled.aside<PaneProps & { readonly $open: boolean }>`
  ${pane};
  display: flex;
  flex: 0 0 auto;
  width: ${({ $open }) => ($open ? 'clamp(280px, 22vw, 340px)' : RAIL_STRIP_WIDTH)};
  overflow-x: hidden;
  overflow-y: ${({ $open }) => ($open ? 'auto' : 'hidden')};
  border-right: 1px solid ${({ theme }) => theme.colors.outlineVariant};
  transition: width ${COLUMN_FOLD_MS}ms ease;
  ${phoneVisibility};
`;

export const CanvasPane = styled.main<PaneProps>`
  ${pane};
  display: flex;
  flex: 1 1 auto;
  ${phoneVisibility};
`;

// Folded rather than unmounted, so a build in progress keeps streaming into it. The column keeps its
// width inside the folding pane, so the chat slides away instead of squeezing.
export const ChatPane = styled.section<PaneProps & { readonly $open: boolean }>`
  ${pane};
  display: flex;
  flex: 0 0 auto;
  width: ${({ $open }) => ($open ? CHAT_WIDTH : '0px')};
  overflow: hidden;
  visibility: ${({ $open }) => ($open ? 'visible' : 'hidden')};
  border-left: ${({ $open }) => ($open ? '1px' : '0px')} solid ${({ theme }) => theme.colors.outlineVariant};
  transition:
    width ${COLUMN_FOLD_MS}ms ease,
    visibility 0s linear ${({ $open }) => ($open ? '0ms' : `${COLUMN_FOLD_MS}ms`)};

  > * {
    width: ${CHAT_WIDTH};
  }

  ${phoneVisibility};

  ${APPS_PHONE_MEDIA} {
    visibility: visible;

    > * {
      width: auto;
    }
  }
`;
